import BaseService from '../BaseService'
import axios from "axios";

class EmailService extends BaseService {
    constructor() {
        super('/catalog');
    }

    modalAll ({ query = '' }) {
        const q = query.length > 0 ? `?${query}` : ''

        return axios.get(`api/v1/modal-catalog${q}`)
    }
}

export default new EmailService()
